export const ADD_WLTR = "ADD_WLTR";
export const DEL_WLTR = "DEL_WLTR";
export const UPDATE_WLTR = "UPDATE_WLTR";
export const CHANGE_WLTRSELROW = "CHANGE_WLTRSELROW";
export const ADD_POMPTR = "ADD_POMPTR";
export const DEL_POMPTR = "DEL_POMPTR";
export const UPDATE_POMPTR = "UPDATE_POMPTR";
export const CHANGE_POMPTRSELROW = "CHANGE_POMPTRSELROW";
export const CHANGE_MEASELROW = "CHANGE_MEASELROW";
export const CHANGE_MEATIMESELROW = "CHANGE_MEATIMESELROW";
export const CHANGE_DELTAT = "CHANGE_DELTAT";
export const ADD_OUTTIMETR = "ADD_OUTTIMETR";
export const DEL_OUTTIMETR = "DEL_OUTTIMETR";
export const UPDATE_OUTTIMETR = "UPDATE_OUTTIMETR";
export const CHANGE_OUTTIMESELROW = "CHANGE_OUTTIMESELROW";
export const UPDATE_LAKETR = "UPDATE_LAKETR";

export function addWLTrAction(ID, NAME, LAT, LON, MEA, DATA) {
  return {
    type: ADD_WLTR,
    NAME: NAME,
    LAT: LAT,
    LON: LON,
    MEA: MEA,
    DATA: DATA,
  };
}

export function delWLTrAction(rowID) {
  return {
    type: DEL_WLTR,
    rowID: rowID,
  };
}

export function updateWLTrAction(value) {
  return {
    type: UPDATE_WLTR,
    value: value,
  };
}

export function changeWLTrSelRowAction(rowID) {
  return {
    type: CHANGE_WLTRSELROW,
    rowID: rowID,
  };
}

export function addPompTrAction(ID, NAME, LAT, LON, MEA, DATA) {
  return {
    type: ADD_POMPTR,
    NAME: NAME,
    LAT: LAT,
    LON: LON,
    MEA: MEA,
    DATA: DATA,
  };
}

export function delPompTrAction(rowID) {
  return {
    type: DEL_POMPTR,
    rowID: rowID,
  };
}

export function updatePompTrAction(value) {
  return {
    type: UPDATE_POMPTR,
    value: value,
  };
}

export function changePompTrSelRowAction(rowID) {
  return {
    type: CHANGE_POMPTRSELROW,
    rowID: rowID,
  };
}

export function changeMeaSelRowAction(value) {
  return {
    type: CHANGE_MEASELROW,
    value: value,
  };
}

export function changeMeaTimeSelRowAction(value) {
  return {
    type: CHANGE_MEATIMESELROW,
    value: value,
  };
}

export function changeDeltaTAction(value) {
  return {
    type: CHANGE_DELTAT,
    value: value,
  };
}

export function addOutTimeTrAction(TIME) {
  return {
    type: ADD_OUTTIMETR,
    TIME: TIME,
  };
}

export function delOutTimeTrAction(rowID) {
  return {
    type: DEL_OUTTIMETR,
    rowID: rowID,
  };
}

export function updateOutTimeTrAction(value) {
  return {
    type: UPDATE_OUTTIMETR,
    value: value,
  };
}

export function changeOutTimeTrSelRowAction(rowID) {
  return {
    type: CHANGE_OUTTIMESELROW,
    rowID: rowID,
  };
}

export function updateLakeTrAction(value) {
  return {
    type: UPDATE_LAKETR,
    value: value,
  };
}
